import { Component, OnInit } from '@angular/core';
import {SidebarService} from "../../../services/sidebar.service";
import {StateService} from "../../../services/state.service";

@Component({
    selector: 'app-admin-wrapper',
    templateUrl: './admin-wrapper.component.html',
    styleUrls: ['./admin-wrapper.component.scss'],
    standalone: false
})
export class AdminWrapperComponent implements OnInit {

  constructor(private sidebarService : SidebarService,
              private stateService : StateService) { }

  ngOnInit(): void {
    // if first time sidebar enabled, enable the toggle, and toggle the sidebar
    if (!this.sidebarService.enabled) {
      this.sidebarService.enabled = true;
      this.sidebarService.toggle(true);
    }
  }

}
